define('Cubix_Stone/js/diamonddhfeed',[
  "jquery",
  "Magento_Theme/js/handlebars.min",
  "Bootsgrid_Vfinance/js/product/finance",
  "owlcarousel",
], function ($, Handlebars, finance) {
  "use strict";
  $.widget("cubix.diamonddhfeed", {
    options: {
      shape: "",
      feedproductpreviewapi: "",
      nonfeedproductpreviewapi: "",
      required_options: "",
      attributesetname: "",
      productConfig: "",
      preview_xhr: "",
      timeout: 0,
      financeobj: finance(),
      img_path: "",
      ringbuilder: 0,
      ringbuildersummary: 0,
      pdp: 0,
      metalpricecalc : "",
      productdelivery : "",
      nonfeedpricecalc : "",
      filter_keys : "",
      discount : "",
      currencysymbol : "",
      highStreetMatrix : "",
      chainShortName : "",
      metalShortName : "",
      attributeSetName : "",
      price_markup : "",
      pricecalcinfo : 0,
    },
    _create: function () {
      this.options.productConfig = this.options.ringbuilder
        ? ""
        : productConfig;
      if(this.options.ringbuilder == 1 || this.options.pricecalcinfo == 1) {
        this.productPreview();
      }
      else {
        this.getProductPrice();
      }
      this._EventListener();
      this._initializeCarousel();
      this.options.financeobj = finance();
    },
    getProductPrice: function () {
      var $widget = this;
        $.ajax({
          url: $widget.options.productfeeds,
          type: 'POST',
          dataType: 'json',
          data: {
              productId: $("input[name=product]").val(),
          },
          success: function(response) {
              $widget.options.metalpricecalc = response.metal_price;
              $widget.options.nonfeedpricecalc = response.diamond_price;
              $widget.options.filter_keys = response.filter_keys;
              $widget.options.productdelivery = response.delivery;
              $widget.options.discount = response.discount;
              $widget.options.currencysymbol = response.currency_symbol;
              $widget.options.highStreetMatrix = response.high_street_matrix;
              $widget.options.chainShortName = response.chain_short_name;
              $widget.options.metalShortName = response.metal_short_name;
              $widget.options.price_markup = response.price_markup;
              $widget.productPreview();
          },
          error: function (xhr, status, errorThrown) {
              console.log('Error happens. Try again.');
          }
      });
    },
    _EventListener: function () {
      var $widget = this;
      var btn_label = "Add To Ring";
      var attributesetname = $widget.options.attributesetname;
      if (attributesetname == "DH Feed Pendants") {
        btn_label = "Add To Pendant";
      }
      $(".diamond-btn-txt").text(btn_label);

      $(document).on("click", ".view-diamond-detail", function () {
        $(".product-block.diamond-item-link").removeClass("active");
        $(this).closest(".product-block.diamond-item-link").addClass("active");
        var diamond_id = $(this).data("id");
        var diamond_type = $(this).data("diamondtype");
        var diamonddata = $(this).data("diamond");
        var diamond = {};
        diamond["Diamond Type"] = diamond_type;
        diamond["Shape"] =
          diamonddata.shape_detail != ""
            ? diamonddata.shape_detail
            : diamonddata.shape;
        diamond["Carat"] = diamonddata.carat;
        if(diamonddata.sidestone_carat > 0) {
          diamond["Side Stone Carat"] = diamonddata.sidestone_carat + 'ct';
        }
        diamond["Colour"] = diamonddata.colour;
        diamond["Clarity"] = diamonddata.clarity;
        diamond["Cut"] = diamonddata.cut;
        diamond["Certificate"] = diamonddata.lab;
        if(diamonddata.certificate_url != '') {
        diamond["Certificate #"] =
          '<a href="' +
          diamonddata.certificate_url +
          '" target="_blank">View</a>';
        }
        diamond["Certificate #"] = diamonddata.certificate_number;
        diamond["Polish"] = diamonddata.polish;
        diamond["Symmetry"] = diamonddata.symmetry;
        diamond["Fluorescence"] = diamonddata.fluo;
        diamond["Table"] = diamonddata.table_percent;
        diamond["Depth"] = diamonddata.depth1;
        diamond["Measurement"] = diamonddata.measurement;
        diamond["Ratio"] = diamonddata.ratio;
        diamond["Girdle"] = diamonddata.girdle;
        diamond["Stock ID"] = diamonddata.internal_stock_id;
        var diamond_gallery = $(this).data("gallery");
        var diamonddata_html = '<div class="diamond-detail-list">';
        $.each(diamond, function (label, value) {
          if (value != undefined && $.trim(value) != "") {
            if(label == "Stock ID") {
              diamonddata_html +=
              '<p class="stckid"><span>' + label + '</span>'+value+'<span data-bs-toggle="tooltip" data-bs-placement="top"  data-bs-html="true" data-bs-custom-class="ringsize-tooltip" title="Click to Copy" class="copy-button ml-1">	<span data-copytext="'+value+'" class="copy-text">&nbsp;</span></span></p>';
            }
            else {
              diamonddata_html +=
                "<p><span>" + label + "</span> " + value + "</p>";
            }
          }
        });
        diamonddata_html += "</div>";
        var diamondPrice = diamonddata.store_code && diamonddata.store_code != "dh" ? diamonddata["price_" + diamonddata.store_code] : diamonddata.price;

        if(diamonddata.is_discount && diamonddata.discounted_price) {
          diamonddata_html +=
          '<div class="price special_price">' + diamonddata.currency_symbol + diamondPrice + "</div>" + 
          '<div class="price discount">' + diamonddata.currency_symbol + parseFloat(diamonddata.discounted_price.toFixed(2)) + "</div>";
        } else {
          diamonddata_html +=
          '<div class="price">' + diamonddata.currency_symbol + diamondPrice + "</div>";
        }
        var type = $(this).attr("data-type");
        if (type == "specificdiamond") {
          diamonddata_html +=
            '<a data-type="specificdiamond" data-id="' +
            diamonddata.id +
            '" data-diamondid="' +
            diamonddata.internal_stock_id +
            '" class="btn btn-dark btn-sm js-click-click-add-diamond clickable" href="javascript: void(0);">' +
            btn_label +
            "</a>";
          var checked = "";
          var dynamic_compare_id = "compare_" + diamond_type + "_" + diamond_id;
          if ($("#" + dynamic_compare_id).prop("checked") == true) {
            checked = "checked";
          }
          diamonddata_html +=
            '<div class="compare d-none"><div class="form-check"><input class="form-check-input alias-addcomparision" data-compareid="' +
            dynamic_compare_id +
            '" id="alias_compare_' +
            dynamic_compare_id +
            '" type="checkbox" ' +
            checked +
            '><label class="form-check-label" for="alias_compare_' +
            dynamic_compare_id +
            '" title="Add to Compare">Compare</label></div></div>';
            $("#pdpdiamonddetail .diamond-detail").html(diamonddata_html);
            $(".popup-diamonddetail-main").show();
        } else {
          diamonddata_html +=
            "<a data-type='recommendus-diamond' data-gallery='" +
            JSON.stringify(diamond_gallery) +
            "' data-diamond='" +
            JSON.stringify(diamonddata) +
            "' data-id='" +
            diamonddata.id +
            "' data-diamondid='" +
            diamonddata.internal_stock_id +
            "' data-diamondtype='" +
            diamonddata.diamondtype +
            "' class='btn btn-dark btn-sm js-click-click-add-diamond clickable' href='javascript: void(0);'>" +
            btn_label +
            "</a>";
            $("#pdpdiamonddetail .diamond-detail").html(
              diamonddata_html
            );
            $(".popup-diamonddetail-main-wizard").show();
        }
        $widget.updateCarousel(diamond_gallery);
        $("#diamonddetailbtn").click();
      });

      $(document).on("click", "#clearselection", function () {
        $('#products-you-may-like, .join_us_social_media').show();
        $('.feed-page-rings').each(function(){
          $(this).removeClass("d-none");
        });
      });

      $(document).on("click", "#specificdiamond, #recommedbyus", function () {
        $("#products-you-may-like, .join_us_social_media").hide();
      });

      $(document).on("click", ".close", function () {
        $("#products-you-may-like, .join_us_social_media").show();
      });

      $(document).on("click", ".close-diamond-detail", function () {
        $(".popup-diamonddetail-main").hide();
        $(".diamond-filter-main").show();
      });

      $(document).on("click", ".close-diamond-detail-wizard", function () {
        $(".popup-diamonddetail-main-wizard").hide();
        $(".diamond-wizard-carousel").show();
      });

      $("input:radio[name=feed_diamond_type]").change(function () {
        var diamond_type = $(this).val();
        $(".diamondtype-filters,.diamondtype-list").hide();
        var selected_filter = "#diamondtype-filters-feed-" + diamond_type;
        var selected_filter_list = "#diamondtype-list-feed-" + diamond_type;
        $(selected_filter).show();
        $(selected_filter_list).show();
        $("#diamond_type")
          .val(diamond_type)
          .trigger("change"); /*only to referesh diamond list*/
        $(".filter-searchbox").hide();
        $("." + diamond_type + ".filter-searchbox").show();
      });

      $(
        "input.nonfeedoption[type=hidden], input[name=selected_configurable_option],input[name=diamond_type]"
      ).change(function () {
        $widget._checkOptionAvailability();
        $widget.productPreview();
      });

      $(document).on("click", ".close-certifcate", function () {
        $("#message-modal").hide();
      });

      $(".custom-certificate input[type=radio]").change(function () {
        var diamondType = $(
          "input:radio[name=nonfeed_diamond_type]:checked"
        ).val();
        var selected_option_text = $(
          "label[for='" + $(this).attr("id") + "']"
        ).text();
        if (selected_option_text == "GIA" || selected_option_text == "IGI") {
          $("#specificdiamond").click();
          $(".certificate_wrap .close-filter").click();

          var certificate = selected_option_text
            .replace(/\//g, "_")
            .toLowerCase();
          var certimage =
            $widget.options.img_path +
            "/pdp/certificate/" +
            certificate +
            ".png";
          var certhtml = $(".certificate-text." + certificate).html();
          var popuphtm =
            '<div class="certificate-pop"><div class="close-certifcate">X</div><div class="d-block d-lg-none"><div class="c-three-dots-loader"></div><h4>Switching to advanced view</h4></div>Please choose your GIA/IGI certified diamond.';
          popuphtm +=
            "<div class='cert-image'><img src='" +
            certimage +
            "' /></div><div class='cert-text'>" +
            certhtml +
            "</div>";
          popuphtm += "</div>";

          $("#message-modal div[data-bind]").html(popuphtm);
          $("#message-modal").css({ display: "flex", "z-index": "100000" });
          $("#message-modal").delay(5000).fadeOut("slow");

          $(
            "#diamondtype-filters-" +
              diamondType +
              " .custom-certificate input[type=radio]:first"
          ).attr("checked", true);
          var selected_option_text = $(
            "label[for='" +
              $(
                "#diamondtype-filters-" +
                  diamondType +
                  " .custom-certificate input[type=radio]:first"
              ).attr("id") +
              "']"
          ).text();
          $("." + diamondType + "-certificate-header").text(
            selected_option_text
          );
        } else {
          $("." + diamondType + "-certificate-header").text(
            selected_option_text
          );
          $widget._checkOptionAvailability();
          $widget.productPreview();
        }
      });

      $(".custom-chain input[type=radio]").change(function () {
        var selected_option_text = $(
          "label[for='" + $(this).attr("id") + "']"
        ).text();
        $(".chain-header").text(selected_option_text);
        $widget._checkOptionAvailability();
        $widget.productPreview();
      });

      $(".custom-ringsize input[type=radio]").change(function () {
        var selected_option_text = $(
          "label[for='" + $(this).attr("id") + "']"
        ).text();
        $(".ringsize-header").text(selected_option_text);
        $widget._checkOptionAvailability();
        $widget.productPreview();
      });

      $(document).on("click", "#product-addtocart-button", function () {
        var err_msg = "";
        var productOptions = $widget.getProductOptions();
        var attributesetname = $widget.options.attributesetname;

        if (
          productOptions.ring_size == "" &&
          attributesetname == "DH Feed Rings"
        ) {
          err_msg = "Please select ring size";
        }

        if (
          productOptions.chain == "" &&
          attributesetname == "DH Feed Pendants"
        ) {
          err_msg = "Please select chain";
        }

        if (productOptions.product_id == "") {
          err_msg = "Please select metal type";
        }

        if (err_msg != "") {
          $(".cart-form-error").html(err_msg);
          return false;
        }
      });

      var metal_type_option = $(".metal_type_option:checked").val();
      if ($widget.options.ringbuilder != 1) {
        var simple_product_id = option_product[metal_type_option];
        $("input[name=selected_configurable_option]").val(simple_product_id);
      }
      $(document).on("change", ".metal_type_option", function () {
        metal_type_option = $(this).val();
        if (metal_type_option != "") {
          simple_product_id = option_product[metal_type_option];
          $("input[name=selected_configurable_option]").val(simple_product_id);
          var metal = $(this).data("metal");
          if ($("." + metal + "_squere.gallery_switcher").length) {
            var gallery = $("." + metal + "_squere.gallery_switcher").data(
              "gallery"
            )[1];
            if (gallery != undefined) {
              $(".diamond-product-img").attr("src", gallery.img);
            }
          }
          $widget.productPreview();
        }
      });

      $(document).on("click", ".js-click-click-add-diamond", function () {
        $(".dynamic_stone_title").html("Your Selected ");
        $widget.change_selected(this);
        $("#products-you-may-like, .join_us_social_media").show();
      });

      $(document).on("click", "#modify-selection", function () {
        var selected_type = $(".diamondbtn.selected").attr("id");
        $("#" + selected_type).click();
        $(".nonfeed-pdp-main").removeClass("d-none");
        if(screen.width < 768) {
          $(".feed-pdp-main").addClass("d-none");
        }
      });

      $(document).on("keypress", ".filter-searchbox", function (e) {
        if (e.which == 13) {
          e.stopPropagation();
          var diamond_type = $(
            "input:radio[name=feed_diamond_type]:checked"
          ).val();
          var search_btn = "#" + diamond_type + "-diamond-search";
          $(search_btn).click();
          return false;
        }
      });
    },
    change_selected: function (element) {
      var $widget = this;
      var diamond_id = $(element).attr("data-diamondid");
      var type = $(element).attr("data-type");
      var diamond_idx = $(element).attr("data-id");
      
      if (type == "specificdiamond") {
        var diamond_type = $(
          "input:radio[name=feed_diamond_type]:checked"
        ).val();
        var diamond_view_cls = $("." + diamond_type + diamond_idx);
        var diamonddata = diamond_view_cls.data("diamond");
        var diamond_gallery = diamond_view_cls.data("gallery");
      } else {
        var diamond_type = $(element).attr("data-diamondtype");
        $("input[name=wizard_diamond_type][value=" + diamond_type + "]").prop(
          "checked",
          true
        );
        var diamond_view_cls = $("." + diamond_type + diamond_idx);
        var diamonddata = JSON.parse($(element).attr("data-diamond"));
        var diamond_gallery = JSON.parse($(element).attr("data-gallery"));
        $(".diamond-wizard-carousel").show();
        $(".popup-diamonddetail-main-wizard").hide();
      }

      $('.view-diamond-detail').removeClass('selected');
      diamond_view_cls.addClass('selected');

      var diamond = {};
      diamond["Shape"] =
        diamonddata.shape_detail != ""
          ? diamonddata.shape_detail
          : diamonddata.shape;
      diamond["Carat"] = diamonddata.carat;
      if(diamonddata.sidestone_carat > 0) {
        diamond["Side Stone Carat"] = diamonddata.sidestone_carat + 'ct';
      }
      diamond["Clarity"] = diamonddata.clarity;
      diamond["Colour"] = diamonddata.colour;
      diamond["Cut"] = diamonddata.cut;
      diamond["Polish"] = diamonddata.polish;
      diamond["Symmetry"] = diamonddata.symmetry;
      diamond["Fluorescence"] = diamonddata.fluorescence;
      diamond["Measurement"] = diamonddata.measurement;
      diamond["Certificate"] = diamonddata.lab;

      var diamonddata_html = "";
      $.each(diamond, function (label, value) {
        if (value != undefined) {
          diamonddata_html += "<p><span>" + label + "</span> " + value + "</p>";
        }
      });

      $(".feed-pdp-main .diamond-detail-list").html(diamonddata_html);

      $(".feed-pdp-main .diamond-deail-img").html(
        '<img src="' + diamond_gallery[0].url + '" />'
      );
      $(".nonfeed-pdp-dt,.nonfeed-pdp-ft").hide();
      $(".feed-pdp-main").removeClass("d-none");
      $(".nonfeed-pdp-main").addClass("d-none");
      $(".diamondbtn").removeClass("selected");
      $(".feed-page-rings").addClass("d-none");
 
      if (type == "specificdiamond") {
        $("#specificdiamond").addClass("selected");
      } else {
        $("#recommedbyus").addClass("selected");
      }

      $("#diamond_id").val(diamond_id);
      $("#selected_diamond_type").val(diamond_type);
      $(".diamonddetail-close").click();
      $('a.tabb').removeClass('active');
      if(diamond_id == '' && $('#clearselection').length > 0) {
        $(".diamondbtn").removeClass("selected");
        $('#clearselection').addClass("selected");
        $("#pdp-nonfeeddiamond").show();
      }
      if(screen.width < 768) {
        $('#design,#delivery-main,.inclued-order-wrap').fadeIn();
      }
      else {
        $('.gallery-section, .product-info-section').fadeIn();
      }
      $("html, body")
        .stop()
        .animate(
          {
            scrollTop: $("#design").offset().top - 280,
          },
          500,
          "swing",
          function () {}
      );
      $widget.productPreview();
    },
    productPreview: function () {
      $("#product_preview").css("opacity", "0.2");
      var $widget = this;
      var diamond_id = $("#diamond_id").val();
      
      var metalpricecalc = $widget.options.metalpricecalc;
      var nonfeedpricecalc = $widget.options.nonfeedpricecalc;
      var filter_keys = $widget.options.filter_keys;
      var productdelivery = $widget.options.productdelivery;
      var discount = $widget.options.discount;
      var currencysymbol = $widget.options.currencysymbol;
      var chainShortName = $widget.options.chainShortName;
      var metalShortName = $widget.options.metalShortName;
      var attributesetname = $widget.options.attributesetname;
      var attributesetnameformatted = attributesetname.replace(/\s/g, '');
      
      if(typeof metalpricecalc !== undefined && typeof nonfeedpricecalc !== undefined && $widget.options.ringbuilder == 0 && $widget.options.pricecalcinfo == 0) {
        var productOptions = $widget.getProductOptions();
        if(productOptions['ring_size'] != '' && productOptions['ring_size'] != undefined) {
          var metalprice = metalpricecalc[productOptions['simple_product_id']][productOptions['ring_size']];  
        }
        else if(productOptions['bracelet_length'] != '' && productOptions['bracelet_length'] != undefined) {
          var metalprice = metalpricecalc[productOptions['simple_product_id']][productOptions['bracelet_length']];
        }
        else if(productOptions['chain'] != '' && productOptions['chain'] != undefined) {
          var metalprice = metalpricecalc[productOptions['simple_product_id']][productOptions['chain']];
        }
        else {
          var metalprice = metalpricecalc[productOptions['simple_product_id']];          
        }
        
        productOptions['delivery'] = productdelivery[productOptions['simple_product_id']];
        var display_final_discounted_price = 0;
        var you_save = 0;
        var diamondprice = 0;
        if(productOptions['intensity'] != '' && productOptions['intensity'] != undefined) {
          productOptions['intensity'] = productOptions['intensity'].toLowerCase();
        }
        
        if (diamond_id != "") {
          var price_markup_type = $widget.options.price_markup[attributesetnameformatted].type;
          var price_markup_sign = $widget.options.price_markup[attributesetnameformatted].sign;
          var price_markup_val = $widget.options.price_markup[attributesetnameformatted].val;
          
          var diamonddata = $('.view-diamond-detail.selected').data("diamond");
          productOptions["carat"] = diamonddata.carat;
          if(diamonddata.sidestone_carat > 0) {
            productOptions["sidestone_carat"] = diamonddata.sidestone_carat + 'ct';
          }
          productOptions["clarity"] = diamonddata.clarity;
          productOptions["colour"] = diamonddata.colour;
          productOptions["cut"] = diamonddata.cut;
          productOptions["lab"] = diamonddata.lab;
          productOptions["width"] = diamonddata.width;
          productOptions["length"] = diamonddata.length;
          productOptions["depth"] = diamonddata.depth;
          diamondprice = parseFloat(diamonddata.price);
        }
        else {
          var attributesetnamemapping = {
            'DH Feed Rings' : 'Non Feed Rings',
            'DH Feed Pendants' : 'Non Feed Pendants'
          };
          
          var attributesetnamemap = attributesetnamemapping[attributesetname];
          var attributesetnamemapformatted = attributesetnamemap.replace(/\s/g, '');
          var price_markup_type = $widget.options.price_markup[attributesetnamemapformatted].type;
          var price_markup_sign = $widget.options.price_markup[attributesetnamemapformatted].sign;
          var price_markup_val = $widget.options.price_markup[attributesetnamemapformatted].val;

          $.each(filter_keys, function(index, keyname) {
            if(diamondprice == 0) {
              diamondprice = nonfeedpricecalc[productOptions['diamond_type']][productOptions[keyname]];
            }
            else {
              diamondprice = diamondprice[productOptions[keyname]];
            }
          });

          var diamond_type = productOptions['diamond_type'];
          $("#diamondtype-filters-" + diamond_type + " .clarity_estimated_price" ).each(function( index,obj ) {
            var clarity = $( obj ).data('clarity');
            var clarity_price = 0;
            var clarity_price_text = '';
            var keyval = '';
            $.each(filter_keys, function(index, keyname) {
              if(keyname == 'clarity') {
                keyval = clarity;
              }
              else {
                keyval = productOptions[keyname];
              }
  
              if(clarity_price == 0) {
                clarity_price = nonfeedpricecalc[productOptions['diamond_type']][keyval];
              }
              else {
                clarity_price = clarity_price[keyval];
              }
            });
  
            if(diamondprice != clarity_price) {
              clarity_price = diamondprice - clarity_price;
              if(clarity_price > 0) {
                clarity_price_text = '-' + currencysymbol + '' + clarity_price.toFixed(2);
              }
              else {
                clarity_price = Math.abs(clarity_price);
                clarity_price_text = '+' + currencysymbol + '' + clarity_price.toFixed(2);
              }
            }
            $( obj ).text(clarity_price_text);
          });
  
          $("#diamondtype-filters-" + diamond_type + " .cut_estimated_price" ).each(function( index,obj ) {
            var cut = $( obj ).data('cut').toLowerCase();
            var cut_price = 0;
            var cut_price_text = '';
            var keyval = '';
            $.each(filter_keys, function(index, keyname) {
              if(keyname == 'cut') {
                keyval = cut;
              }
              else {
                keyval = productOptions[keyname];
              }
  
              if(cut_price == 0) {
                cut_price = nonfeedpricecalc[productOptions['diamond_type']][keyval];
              }
              else {
                cut_price = cut_price[keyval];
              }
            });
  
            if(diamondprice != cut_price) {
              cut_price = diamondprice - cut_price;
              if(cut_price > 0) {
                cut_price_text = '-' + currencysymbol + '' + cut_price.toFixed(2);
              }
              else {
                cut_price = Math.abs(cut_price);
                cut_price_text = '+' + currencysymbol + '' + cut_price.toFixed(2);
              }
            }
            $( obj ).text(cut_price_text);
          });
  
          $("#" + diamond_type + "nonfeedcolourSlider  .ui-slider-label" ).each(function( index,obj ) {
            var colour = $( obj ).data('colour');
            if(colour == undefined || colour == '') {
              var colour = $.trim( $( obj ).text() );
              $(obj).attr('data-colour', colour);
            }
  
            var colour_price = 0;
            var colour_price_text = '';
            var keyval = '';
            $.each(filter_keys, function(index, keyname) {
              if(keyname == 'colour') {
                keyval = colour;
              }
              else {
                keyval = productOptions[keyname];
              }
  
              if(colour_price == 0) {
                colour_price = nonfeedpricecalc[productOptions['diamond_type']][keyval];
              }
              else {
                colour_price = colour_price[keyval];
              }
            });
  
            if(diamondprice != colour_price) {
              colour_price = diamondprice - colour_price;
              if(colour_price > 0) {
                colour_price_text = '-' + currencysymbol + '' + colour_price.toFixed(2);
              }
              else {
                colour_price = Math.abs(colour_price);
                colour_price_text = '+' + currencysymbol + '' + colour_price.toFixed(2);
              }
            }
            $('.colour-price-'+colour).remove();
            if(colour_price_text != '') {
              $(obj).after('<span class="colour_estimated_price colour-price-'+colour+'">'+colour_price_text+'</span>');
            }
          });
        }

        var total_price = metalprice + diamondprice;
        if (diamond_id != "") {
          price_markup_val = (price_markup_type == 'percent' && price_markup_val > 0) ? metalprice  * price_markup_val / 100 : price_markup_val;
        }
        else {
          price_markup_val = (price_markup_type == 'percent' && price_markup_val > 0) ? total_price  * price_markup_val / 100 : price_markup_val;
        }

        if(price_markup_sign != '' && price_markup_val > 0) {
          total_price = eval(total_price + price_markup_sign + price_markup_val);
        }

        var plain_price = total_price;
        var high_street_price = $widget.getHighStreetPrice(total_price);
        you_save = currencysymbol + '' + (high_street_price - total_price).toFixed(2);
        
        if(discount['is_discount'] == 1) {
          if (discount['discount_percent'] > 0) {
              display_final_discounted_price = total_price - ((total_price * discount['discount_percent']) / 100);
          } else if (discount['discount_amount'] > 0) {
              display_final_discounted_price = total_price - discount['discount_amount'];
          }
          else {
            display_final_discounted_price = total_price
          }

          if(display_final_discounted_price > 0){
              you_save = high_street_price - display_final_discounted_price;
              you_save = currencysymbol + '' + you_save.toFixed(2);
              plain_price = display_final_discounted_price;
              display_final_discounted_price = currencysymbol + '' + display_final_discounted_price.toFixed(2);
          }
        }
        productOptions['high_street_price'] = currencysymbol + '' + high_street_price.toFixed(2);
        productOptions['display_final_discounted_price'] = display_final_discounted_price;
        productOptions['you_save'] = you_save;
        productOptions['is_discount'] = discount['is_discount'];
        productOptions['description'] = discount['description'];
        productOptions['display_price'] = currencysymbol + '' + total_price.toFixed(2);
        productOptions['plain_price'] = plain_price;
        productOptions['metal_short_label'] = (metalShortName[productOptions['metal']] != undefined) ? metalShortName[productOptions['metal']] : productOptions['metal'];
        productOptions['chain_short_label'] = (chainShortName[productOptions['chain']] != undefined) ? chainShortName[productOptions['chain']] : productOptions['chain'];


        // TODO: Double check and add this at proper place 
        // -------------------------------------------------------------------------------       
        $('.gallery-section, .product-info-section').fadeIn();
        $('#pdp-specificdiamond,#pdp-recommedbyus').fadeOut();
        // -------------------------------------------------------------------------------       

        $widget.reloadSummary(productOptions);
      }
      else {
        if (diamond_id != "" || $widget.options.ringbuilder == 1) {
          var productpreviewapi = $widget.options.feedproductpreviewapi;
        } else {
          var productpreviewapi = $widget.options.nonfeedproductpreviewapi;
        }

        if (
          $widget.options.preview_xhr &&
          $widget.options.preview_xhr.readystate != 4
        ) {
          $widget.options.preview_xhr.abort();
        }
        $('.gallery-section, .product-info-section').fadeIn();
        $('#pdp-specificdiamond,#pdp-recommedbyus').fadeOut();
        
        $widget.options.preview_xhr = jQuery.ajax({
          type: "POST",
          url: productpreviewapi,
          data: $widget.getProductOptions(),
          dataType: "json",
          success: function (data) {
            if (data.result == "success") {
              $widget.reloadSummary(data.data);
            } else {
              $(".cart-form-error").html(data.message);
              $("#product-addtocart-button").attr("disabled", true);
            }
          },
          failure: function (errMsg) {
            console.log(errMsg);
          },
        });
      }
    },
    reloadSummary: function (data) {
      var $widget = this;
      if ($widget.options.ringbuilder == 1 && $widget.options.pdp == 0) {
        $("#dh_loading").hide();
        $(".ringbuilder-rrp").text(data.high_street_price);
        if (data && data.you_save) {
          $(".ringbuilder-you-save").text(data.you_save);
        }
        $(".setting-price").text(data.product_price);
        var screenWidth = $(window).width();

        if(data.sidestone_carat) {
        $('.sidestone-detail').html(data.sidestone_diamond_type + ' / ' + data.sidestone_carat + 'ct x ' + data.sidestone_total_diamonds + ' / ' + data.sidestone_clarity + ' / ' + data.sidestone_colour);
        }

        if (
          data.display_final_discounted_price &&
          data.is_discount
        ) {
            $(".ringbuilder-price")
              .text(data.display_final_discounted_price);
            $(".original-stricked-price")
              .text(data.display_price);
        } else {
          $(".original-stricked-price").hide();
          $(".ringbuilder-price").text(data.display_price);
          
        }

        $("#product_preview").css("opacity", "1");
        $("#product_total").val(data.plain_price);
        var templateId = "template-delivery";
        var source = document.getElementById(templateId).innerHTML;
        var template = Handlebars.compile(source);
        var html = template(data);
        $(".delivery-info").html(html);
      } else {
        $widget.renderProductPreview(data);
        $("#product-addtocart-button").attr("disabled", false);
        $("#product_preview").css("opacity", "1");
        $("#dh_loading").hide();
        $("#product_total").val(data.plain_price);

        if (
          $(".expand_preview").length &&
          $(".dropdown-menu.show").length == 0
        ) {
          $(".expand_preview").trigger("click");
          var selected_type = $(".diamondbtn.selected").attr("id");
          if ($widget.timeout > 0) {
            clearTimeout($widget.timeout);
          }
          if (selected_type == "clearselection") {
            $widget.timeout = setTimeout(function () {
              $(".expand_preview").trigger("click");
            }, 3000);
          }
        }
      }
      $widget.options.financeobj.loadFinance();
    },
    getHighStreetPrice: function (settingPrice) {
      var $widget = this;
      var highStreetMatrix = $widget.options.highStreetMatrix;
      var highStreetPrice = settingPrice;
      if(settingPrice < 1000) {
          highStreetPrice = highStreetPrice * highStreetMatrix['1000'];
      }
      else if(settingPrice >= 1000 && settingPrice < 2000) {
          highStreetPrice = highStreetPrice * highStreetMatrix['2000'];
      }
      else if(settingPrice >= 2000 && settingPrice < 3000) {
          highStreetPrice = highStreetPrice * highStreetMatrix['3000'];
      }
      else if(settingPrice >= 3000 && settingPrice < 4000) {
          highStreetPrice = highStreetPrice * highStreetMatrix['4000'];
      }
      else {
          highStreetPrice = highStreetPrice * highStreetMatrix['4001'];
      }
      return highStreetPrice;
    },
    getProductOptions: function () {
      var $widget = this;
      var productOptions;
      var diamond_id = $("#diamond_id").val();
      if (diamond_id != "") {
        var diamondType = $("#selected_diamond_type").val();
      } else {
        var diamondType = $(
          "input:radio[name=nonfeed_diamond_type]:checked"
        ).val();
      }

      var product_id = $("input[name=product]").val();
      var simple_product_id = $(
        "input[name=selected_configurable_option]"
      ).val();
      var ring_size = "";
      var chain = "";
      var chain_type = "";
      var attributesetname = $widget.options.attributesetname;
      if (attributesetname == "DH Feed Rings") {
        ring_size = $(".custom-ringsize input[type='radio']:checked").val();
      } else if (attributesetname == "DH Feed Pendants") {
        chain = $(".custom-chain input[type='radio']:checked").val();
        chain_type = 1;
      }

      var metal_type_option = $(".metal_type_option:checked").val();
      if (simple_product_id == "") {
        simple_product_id = option_product[metal_type_option];
      }

      var intensity = $("input[name='" + diamondType + "intensity']").val();
      var colour = $("input[name='" + diamondType + "colour']").val();
      
      if($.inArray(diamondType, ['yellow','ruby','sapphire']) !== -1 && colour == undefined) {
        colour = 'Very Light';
      }
      
      if($.inArray(diamondType, ['black']) !== -1 && intensity == undefined) {
        intensity = 'very light';
      }

      productOptions = {
        diamond_id: diamond_id,
        product_id: product_id,
        simple_product_id: simple_product_id,
        diamond_type: diamondType,
        ring_size: ring_size,
        chain: chain,
        chain_type: chain_type,
        attributesetname: attributesetname,
        ringbuildersummary: $widget.options.ringbuildersummary,
        colour: $("#" + diamondType + "fancycolour").val(),
        metal: $.trim(
          $(
            "label[for='" + $(".metal_type_option:checked").attr("id") + "']"
          ).text()
        ),
        shape: this.options.shape,
        colour: colour,
        clarity: $("input[name='" + diamondType + "clarity']:checked").val(),
        carat: $("input[name='" + diamondType + "carat']").val(),
        cut: ($("input[name='" + diamondType + "cut']").length > 0) ? $("input[name='" + diamondType + "cut']:checked").val().toLowerCase() : 'good',
        intensity: intensity,
        lab: ($("input[name='" + diamondType + "certificate']").length > 0) ? $("input[name='" + diamondType + "certificate']:checked").val() : 'GIE',
        diamondType: diamondType,
        ringbuilder: $widget.options.ringbuilder,
      };

      return productOptions;
    },
    renderProductPreview: function (data, cls) {
      var templateId = "template-productpreview";
      var source = document.getElementById(templateId).innerHTML;
      var template = Handlebars.compile(source);
      var html = template(data);
      $("#product_preview").html(html);

      if($('#mobile-productpreview').length > 0) {
        var templateId = "template-productpreviewmobile";
        var source = document.getElementById(templateId).innerHTML;
        var template = Handlebars.compile(source);
        var html = template(data);
        $("#mobile-productpreview").html(html);
      }

      var templateId = "template-delivery";
      var source = document.getElementById(templateId).innerHTML;
      var template = Handlebars.compile(source);
      var html = template(data);
      $(".delivery-info").html(html);
    },
    _checkOptionAvailability: function (carat) {
      var $widget = this;
      var diamondType = $(".diamond_type:checked").val();

      if (carat == undefined || carat == "") {
        carat = $("." + diamondType + "nonfeedcaratVal").val();
      }
      var certificate = $(
        "input[name='" + diamondType + "certificate']:checked"
      ).val();
      $("." + diamondType + "-wrap .cert-form-error").html("");
      $("#product-addtocart-button").prop("disabled", false);

      var required_options = $widget.options.required_options;
      if (required_options.lab != false) {
        var cert_options = false;
        var cert_status = "valid";

        if (certificate == "GIA") {
          var cert_options = required_options.lab.gia;
          var cert_status = cert_options[carat];
          $("." + diamondType + " .gia")
            .removeClass("valid invalid")
            .addClass(cert_status);
        }

        if (certificate == "IGI") {
          var cert_options = required_options.lab.igi;
          var cert_status = cert_options[carat];
          $("." + diamondType + " .igi")
            .removeClass("valid invalid")
            .addClass(cert_status);
        }

        if (cert_status == "invalid") {
          $("." + diamondType + "-wrap .cert-form-error").html(
            "This diamond combination is unavailable in the selected certificate."
          );
          $("#product-addtocart-button").prop("disabled", true);
        } else {
          $("#product-addtocart-button").prop("disabled", false);
          $("." + diamondType + "-wrap .cert-form-error").html("");
        }
      }
    },
    updateCarousel: function (gallery_data) {
      var html = "";
      var thumb_html = "";
      $.each(gallery_data, function (i, data) {
        html += '<div class="item">';
        if (data.is_video) {
          var videoURL= data.url.replace('500', '300');
          var videoURL1= videoURL.replace('500', '300');
          html += '<iframe scrolling="no" src="' + videoURL1 + '"></iframe>';
        } else {
          html += '<img src="' + data.url + '"/>';
        }
        html += "</div>";

        thumb_html += '<div class="item">';
        thumb_html += '<img src="' + data.thumb + '">';
        thumb_html += "</div>";
      });

      if (html != "") {
        var sync1 = $(".diamond_sync1").owlCarousel();
        sync1
          .trigger("replace.owl.carousel", html)
          .trigger("refresh.owl.carousel");

        if (gallery_data.length > 1) {
          $(".diamond_sync2").show();
          var sync2 = $(".diamond_sync2").owlCarousel();
          sync2
            .trigger("replace.owl.carousel", thumb_html)
            .trigger("refresh.owl.carousel");
        } else {
          $(".diamond_sync2").hide();
        }
      }
    },
    _initializeCarousel: function () {
      var $widget = this;
      var sync1 = $(".diamond_sync1");
      var sync2 = $(".diamond_sync2");
      var slidesPerPage = 2;
      var syncedSecondary = true;

      sync1
        .owlCarousel({
          items: 1,
          slideSpeed: 2000,
          nav: true,
          autoplay: false,
          dots: false,
          loop: false,
          responsiveRefreshRate: 200,
          navText: [
            '<svg width="100%" height="100%" viewBox="0 0 11 20"><path style="fill:none;stroke-width: 1px;stroke: #000;" d="M9.554,1.001l-8.607,8.607l8.607,8.606"/></svg>',
            '<svg width="100%" height="100%" viewBox="0 0 11 20" version="1.1"><path style="fill:none;stroke-width: 1px;stroke: #000;" d="M1.054,18.214l8.606,-8.606l-8.606,-8.607"/></svg>',
          ],
        })
        .on("changed.owl.carousel", function (el) {
          var count = el.item.count - 1;
          var current = Math.round(el.item.index - el.item.count / 2 - 0.5);

          if (current < 0) {
            current = count;
          }
          if (current > count) {
            current = 0;
          }

          sync2
            .find(".owl-item")
            .removeClass("current")
            .eq(current)
            .addClass("current");
          var onscreen = sync2.find(".owl-item.active").length - 1;
          var start = sync2.find(".owl-item.active").first().index();
          var end = sync2.find(".owl-item.active").last().index();

          if (current > end) {
            sync2.data("owl.carousel").to(current, 100, true);
          }
          if (current < start) {
            sync2.data("owl.carousel").to(current - onscreen, 100, true);
          }
        });

      sync2
        .on("initialized.owl.carousel", function () {
          sync2.find(".owl-item").eq(0).addClass("current");
        })
        .owlCarousel({
          items: slidesPerPage,
          dots: false,
          nav: false,
          smartSpeed: 200,
          slideSpeed: 500,
          slideBy: slidesPerPage,
          responsiveRefreshRate: 100,
        })
        .on("changed.owl.carousel", function (el) {
          if (syncedSecondary) {
            var number = el.item.index;
            sync1.data("owl.carousel").to(number, 100, true);
          }
        });

      sync2.on("click", ".owl-item", function (e) {
        e.preventDefault();
        var number = $(this).index();
        sync1.data("owl.carousel").to(number, 300, true);
      });
    }
  });
  return $.cubix.diamonddhfeed;
});

